import Request from "@/services/request";
import { SURVEYS_QUERY } from "@/utils/enum/endpoints";

const request = new Request();
import {
  GET_SURVEYS_PENDING,
  GET_SURVEYS_SUCCESS,
  GET_SURVEYS_FAIL,
  SURVEYS_ANSWERS_PENDING,
  SURVEYS_ANSWERS_SUCCESS,
  SURVEYS_ANSWERS_FAIL,
  GET_SURVEYS_RESULT_PENDING,
  GET_SURVEYS_RESULT_SUCCESS,
  GET_SURVEYS_RESULT_FAIL,
  SET_SHOW_SURVEY_VERIFICATION,
  SET_SHOW_SURVEY
} from "./mutation-types";

export default {
  async getSurveysModule({ commit, rootState }) {
    commit(GET_SURVEYS_PENDING);
    try {
      const sellerId = rootState.auth?.user?.sellerId;
      if (!sellerId) {
        throw new Error('Seller ID not found');
      }
      
      const { data } = await request.get(
        `${SURVEYS_QUERY}/${sellerId}/get-top-survey`
      );
      
      commit(GET_SURVEYS_SUCCESS, data);
      
      if (data?.surveyQuestions?.length > 0) {
        commit('SET_SHOW_SURVEY', true);
        commit('SET_CURRENT_QUESTION_NUMBER', 1);
      }
      return data;
    } catch (error) {
      commit(GET_SURVEYS_FAIL);
      return Promise.reject(error?.data || error);
    }
  },

  async requestSurveyAnswers({ commit, rootState }, payload) {
    commit(SURVEYS_ANSWERS_PENDING);
    try {
      const sellerId = rootState.auth?.user?.sellerId;
      if (!sellerId) {
        throw new Error('Seller ID not found');
      }
      
      const { data } = await request.post(
        `${SURVEYS_QUERY}/${sellerId}/survey-answer`,
        payload
      );
      commit(SURVEYS_ANSWERS_SUCCESS);
      commit(SET_SHOW_SURVEY_VERIFICATION,true);
      commit(SET_SHOW_SURVEY,false);
      return data;
    } catch (error) {
      commit(SURVEYS_ANSWERS_FAIL);
      return Promise.reject(error?.data || error);
    }
  },

  async getSurveyResults({ state, commit, rootState }) {
    commit(GET_SURVEYS_RESULT_PENDING);
    try {
      const sellerId = rootState.auth?.user?.sellerId;
      if (!sellerId) {
        throw new Error('Seller ID not found');
      }
      
      const surveyId = state.survey?.surveyId;
      if (!surveyId) {
        throw new Error('Survey ID not found');
      }
      
      const { data } = await request.get(
        `${SURVEYS_QUERY}/${sellerId}/get-survey-answer-ratio/${surveyId}`
      );
      commit(GET_SURVEYS_RESULT_SUCCESS, data);
      return data;
    } catch (error) {
      commit(GET_SURVEYS_RESULT_FAIL);
      return Promise.reject(error?.data || error);
    }
  },
};
